import React, { useState } from 'react';
import { Button, Col, Form, InputNumber, Modal, Row, Tag, Typography } from 'antd';
import { CheckCircleOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

import QuickTurnPartStore from 'stores/QuickTurnPartStore';
import { Link } from 'react-router-dom';
import { Price } from '@partsbadger/library';
import { Share } from '../Share';

const { Text } = Typography;

const Pricing: React.FC = () => {
    const [visible, setVisible] = useState(false);
    const history = useHistory();

    const percentageDiscount = (qtyOnePrice: number, volumePrice: number) => {
        return (100 - (Number(volumePrice) / qtyOnePrice) * 100).toFixed(0);
    };

    function handleChange(): void {
        if (QuickTurnPartStore.partToken) {
            QuickTurnPartStore.updatePartById(QuickTurnPartStore.partToken);
        }
    }

    const handleSubmit = async () => {
        await QuickTurnPartStore.addPartToCart();

        // setVisible(true);

        history.push('/quick-turn/cart');
    };

    return (
        <>
            <div className="d-flex flex-column">
                <div className="d-flex flex-xl-row flex-lg-column-reverse flex-md-row flex-row justify-content-between mb-3">
                    <div className="quantity-selector d-flex flex-row align-items-center">
                        <div className="d-flex flex-column align-items-start">
                            <label htmlFor="quantity-input" className="ant-form-item-label mb-1">
                                Quantity
                            </label>
                            <div className="button-group">
                                <Button
                                    size="small"
                                    className="minus-btn"
                                    icon={<MinusOutlined />}
                                    onClick={() => {
                                        if (QuickTurnPartStore.quantity > 1) {
                                            QuickTurnPartStore.setQuantity(QuickTurnPartStore.quantity - 1);
                                            handleChange();
                                        }
                                    }}
                                    disabled={QuickTurnPartStore.quantity === 1}
                                />
                                <Form.Item noStyle>
                                    <InputNumber
                                        id="quantity-input"
                                        min={1}
                                        max={1000}
                                        step={1}
                                        controls={false}
                                        size="small"
                                        value={QuickTurnPartStore.quantity}
                                        onPressEnter={(e: any) => {
                                            if (e.target.value) {
                                                QuickTurnPartStore.setQuantity(Number(e.target.value));
                                                handleChange();
                                            }
                                        }}
                                        onBlur={e => {
                                            if (e.target.value) {
                                                QuickTurnPartStore.setQuantity(Number(e.target.value));
                                                handleChange();
                                            }
                                        }}
                                    />
                                </Form.Item>
                                <Button
                                    size="small"
                                    className="plus-btn"
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        if (QuickTurnPartStore.quantity < 1000) {
                                            QuickTurnPartStore.setQuantity(QuickTurnPartStore.quantity + 1);
                                            handleChange();
                                        }
                                    }}
                                    disabled={QuickTurnPartStore.quantity === 1000}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="d-flex flex-column text-right align-items-end">
                        <div
                            className="d-flex flex-row font-size-xxl"
                            style={{ columnGap: '4px', whiteSpace: 'nowrap' }}
                        >
                            <span className="font-weight-semibold plus-jakarta-sans">
                                <Price value={QuickTurnPartStore.price} />
                            </span>
                            <span className="font-weight-light">/pc</span>
                        </div>
                        {QuickTurnPartStore.quantity > 1 ? (
                            <Tag color="green" className="rounded-pill font-size-md m-0">
                                -{percentageDiscount(QuickTurnPartStore.qtyOnePrice, QuickTurnPartStore.price)}%
                            </Tag>
                        ) : null}
                    </div>
                </div>
                <Button
                    size="middle"
                    id="quickturn-add-to-cart"
                    block
                    className="mb-2"
                    type="primary"
                    style={{ fontWeight: 500, letterSpacing: '1px', textTransform: 'uppercase' }}
                    onClick={() => {
                        handleSubmit();
                    }}
                >
                    Add To Cart
                </Button>

                <Share />
            </div>

            <Modal open={visible} closable={true} footer={null} centered={true} onCancel={() => setVisible(false)}>
                <Row gutter={[8, 0]} className="mb-0">
                    <Col span={24} className="text-center mb-3">
                        <Text className="font-size-xxl font-weight-med">
                            <CheckCircleOutlined /> Part Added to Cart
                        </Text>
                    </Col>
                    <Col span={12}>
                        <Button type="default" size="large" block={true}>
                            Start a New Part
                        </Button>
                    </Col>
                    <Col span={12}>
                        <Button type="primary" size="large" block={true} onClick={() => setVisible(false)}>
                            <Link to="/quick-turn/cart">View Cart</Link>
                        </Button>
                    </Col>
                </Row>
            </Modal>
        </>
    );
};

export default Pricing;
